/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameIntroView, IGameIntroViewConfig} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

import {TimelineMax} from "gsap";
import {FruitsGameAssets} from "../FruitsGameAssets";
import { IStillImageBgIntroViewConfig } from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SlotApiEventIntroCommand } from "@nolimitcity/slot-game/bin/core/slotapiadapter/event/SlotApiEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";

export class FruitsGameIntroView extends GameIntroView {

    private _graphicContainer:PIXI.Container;
    private _feature1:PIXI.Sprite;
    private _feature2:PIXI.Sprite;
    private _feature3:PIXI.Sprite;
    private _logo:PIXI.Sprite;
    private _light:PIXI.spine.Spine;
    private _bgContainer:PIXI.Container;
    private _container:PIXI.Container;
    private _fruitsBg:PIXI.Sprite;
    private _animationName:string = "Light_A";

    constructor(config:IStillImageBgIntroViewConfig) {
        super(config);
        EventHandler.addEventListener(this, SlotApiEventIntroCommand.API_READY, (event:GameEvent) => {});
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._container = new PIXI.Container();
        this._graphicContainer = new PIXI.Container();
        this._bgContainer = new PIXI.Container();

        this._fruitsBg = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.MAIN_GAME_BACKGROUND_LANDSCAPE)[0]);
        this._fruitsBg.anchor.set(0.5, 0.5);
        this._fruitsBg.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        this._feature1 = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.IS_FEATURE_1)[0]);
        this._feature1.anchor.set(0.5, 0.5);
        this._feature1.scale.set(0.85, 0.85);
        this._feature1.position.set(this._screenWidth * 0.25, this._screenHeight * 0.55);

        this._feature2 = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.IS_FEATURE_2)[0]);
        this._feature2.anchor.set(0.5, 0.5);
        this._feature2.scale.set(0.85, 0.85);
        this._feature2.position.set(this._screenWidth * 0.5, this._screenHeight * 0.55);

        this._feature3 = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.IS_FEATURE_3)[0]);
        this._feature3.anchor.set(0.5, 0.5);
        this._feature3.scale.set(0.85, 0.85);
        this._feature3.position.set(this._screenWidth * 0.75, this._screenHeight * 0.55);

        this._logo = new PIXI.Sprite(GameResources.getTextures("logo")[0]);
        this._logo.anchor.set(0.5, 0.5);
        this._logo.scale.set(1.5, 1.5);
        this._logo.position.set(this._screenWidth * 0.5, this._screenHeight * 0.2);


        this._light = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBackgroundIdle"));
        this._light.position.set(650, 380);

        this._bgContainer.addChild(this._fruitsBg);
        this._bgContainer.addChild(this._light);
        this._graphicContainer.addChild(this._feature1);
        this._graphicContainer.addChild(this._feature2);
        this._graphicContainer.addChild(this._feature3);
        this._graphicContainer.addChild(this._logo);

        this._container.addChild(this._bgContainer);
        this._container.addChild(this._graphicContainer);

        this.playSpine();

        return this._container;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {

        this._bgContainer.removeChild(this._fruitsBg);
        this._bgContainer.removeChild(this._light);

        if(resizeData.orientation === "portrait") {
            this._fruitsBg = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.MAIN_GAME_BACKGROUND_PORTRAIT)[0]);
            this._feature1.position.set(this._screenWidth * 0.25, this._screenHeight * 0.4);
            this._feature2.position.set(this._screenWidth * 0.5, this._screenHeight * 0.6);
            this._feature3.position.set(this._screenWidth * 0.75, this._screenHeight * 0.4);
            this._logo.position.set(this._screenWidth * 0.5, this._screenHeight * 0.2);
            this._feature1.scale.set(1, 1);
            this._feature2.scale.set(1, 1);
            this._feature3.scale.set(1, 1);
            this._logo.scale.set(1, 1);

            this._animationName = "Light_Portrait";
            this._light = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBackgroundIdlePortrait"));
            this._light.position.set(0, 800);
        }

        else {
            this._fruitsBg = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.MAIN_GAME_BACKGROUND_LANDSCAPE)[0]);
            this._feature1.position.set(this._screenWidth * 0.25, this._screenHeight * 0.55);
            this._feature2.position.set(this._screenWidth * 0.5, this._screenHeight * 0.55);
            this._feature3.position.set(this._screenWidth * 0.75, this._screenHeight * 0.55);
            this._logo.position.set(this._screenWidth * 0.5, this._screenHeight * 0.2);
            this._feature1.scale.set(0.85, 0.85);
            this._feature2.scale.set(0.85, 0.85);
            this._feature3.scale.set(0.85, 0.85);
            this._logo.scale.set(0.75, 0.75);

            this._animationName = "Light_A";
            this._light = new PIXI.spine.Spine(GameResources.getSpineAsset("spineBackgroundIdle"));
            this._light.position.set(650, 380);
        }

        this._fruitsBg.anchor.set(0.5, 0.5);

        if(this._fruitsBg) {
            const imgRatio = this._fruitsBg.width / this._fruitsBg.height;
            imgRatio.toFixed(2);

            if(this._screenWidth > this._fruitsBg.width) {
                this._fruitsBg.width = this._screenWidth;
                this._fruitsBg.height = this._screenWidth / imgRatio;
            }


            this._fruitsBg.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        }

        this._bgContainer.addChild(this._fruitsBg);
        this._bgContainer.addChild(this._light);

        this.playSpine();
    }

    protected stopPresentation(closeCallback?:() => void):void {
        super.stopPresentation(closeCallback);
        this.removeChildren();
    }

    private playSpine(){
        const tl:TimelineMax = new TimelineMax({repeat : -1, repeatDelay : 0});


        tl.add(new SpineTween(this._light, 0, this._animationName));
    }
}